import AuthView from "../views/auth/AuthView";
import Home from "../views/main/Home";
import NewDistributer from "../views/main/NewDistributer";

let routes = [
    // {
    //     path: "/auth",
    //     component: AuthView,
    //     layout: "auth",
    // },
    {
        path: "/",
        component: Home,
        layout: "main",
    },
    {
        path: "/new-distributer",
        component: NewDistributer,
        layout: "main",
    },
];
export default routes;
